module.exports = __webpack_public_path__ + "img/more-info.c5fffd24.svg";